import moment from 'moment';
import { IResponse } from '../../model';

export enum Stores {
  StoreControl = 'store-control',
  Clientes = 'clientes',
  Cotizadores = 'cotizadores',
  Paises = 'paises',
  Regiones = 'regiones',
  Monedas = 'monedas',
  MedioPagos = 'mediospago',
  Usuarios = 'usuarios'
}

export type IdType = IDBValidKey | IDBKeyRange;

export default class IndexedDBService {  
  private db: IDBDatabase | null = null;
  private version = 2;

  private use = <T>(fx: (db: IDBDatabase) => Promise<T>) : Promise<T> => new Promise((res,rej) => {
    let request = indexedDB.open(`CNET-BO-${window.app_enviroment}`, this.version);
    
    request.onupgradeneeded = async (e) => {
      this.db = request.result;

      if (e.oldVersion >= 1 && e.newVersion === 2) { // borra los usuarios para que se regenere
        //this.db.deleteObjectStore(Stores.Usuarios);
        await this.put(Stores.StoreControl, { key: Stores.Usuarios, date: new Date(new Date().setFullYear(2000)) } );
      }

      Object.keys(Stores).forEach(store => {
        if (!this.db!.objectStoreNames.contains(store))
          this.db!.createObjectStore((Stores as any)[store], { keyPath: 'id' });
      })
    };
    
    request.onsuccess = () => {
      this.db = request.result;
      res(fx(this.db!));
    };

    request.onerror = (ev: Event) => {
      console.error("IndexedDBService.open().onError", request.error?.message, ev);
      rej(new Error(`${request.error?.message}`));
    };
  });

  all = <T>(storeName: Stores) : Promise<T[]> => this.use((db) => new Promise((res,rej) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const query = store.getAll();
    query.onsuccess = () => res(query.result);
    query.onerror = () => rej(new Error(query.error?.message));
  }));

  allIds = (storeName: Stores) : Promise<IdType[]> => this.use((db) => new Promise((res,rej) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const query = store.getAllKeys();
    query.onsuccess = () => res(query.result);
    query.onerror = () => rej(new Error(query.error?.message));
  }));

  add = <T>(storeName: Stores, element: T) : Promise<IdType> => this.use((db) => new Promise((res,rej) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const query = store.add(element);
    query.onsuccess = () => res(query.result);
    query.onerror = () => rej(new Error(query.error?.message));
  }));

  delete = (storeName: Stores, id: IdType) : Promise<unknown> => this.use((db) => new Promise((res,rej) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const query = store.delete(id);
    query.onsuccess = () => res(query.result);
    query.onerror = () => rej(new Error(query.error?.message));
  }));

  get = <T>(storeName: Stores, id: IdType) : Promise<T> => this.use((db) => new Promise((res,rej) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const query = store.get(id);
    query.onsuccess = () => res(query.result);
    query.onerror = () => rej(new Error(query.error?.message));
  }));

  clear = (storeName: Stores) : Promise<unknown> => this.use((db) => new Promise((res,rej) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const query = store.clear();
    query.onsuccess = () => res(query.result);
    query.onerror = () => rej(new Error(query.error?.message));
  }));
  
  put = <T>(storeName: Stores, element: T) : Promise<IdType> => this.use((db) => new Promise((res,rej) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const query = store.put(element);
    query.onsuccess = () => res(query.result);
    query.onerror = () => rej(new Error(query.error?.message));
  }));

  store = <T>(storeName: Stores, element: T) : Promise<IDBObjectStore> => this.use((db) => new Promise((res,rej) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    res(store);
  }));

  transaction = <T>(storeName: Stores, element: T) : Promise<IDBTransaction> => this.use((db) => new Promise((res,rej) => {
    const tx = db.transaction(storeName, 'readwrite');
    res(tx);
  }));

  addRange = <T>(storeName: Stores, elements: T[]) : Promise<IdType[]> => this.use((db) => new Promise((res,rej) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);

    const result : IdType[] = [];
    const add = (element: T) => new Promise((res2, rej2) => {
      const query = store.add(element);
      query.onsuccess = () => res2(query.result);
      query.onerror = () => rej2(new Error(query.error?.message));  
    });

    const run = Promise.resolve(undefined);
    for(var i = 0; i < elements.length; i++) {
      const element = elements[i];
      run.then(p => {
        if (!!p) result.push(p);
        return add(element);
      });
    }

    return run.then(p => {
      if (!!p) result.push(p);
      res(result);
    }).catch(err => rej(err));
  }));
 

  
  StoreControl = {
    
    apiget: <T>(store: Stores, api: () => Promise<IResponse<T[]>>) : Promise<IResponse<T[]>> => {
      const service = new IndexedDBService();
      type ControlType = {
        id: Stores;
        date: Date;
      }
      return Promise.resolve(true)
        // obtengo el registro del control
        .then(() => service.get<ControlType>(Stores.StoreControl, store))
        // verifico que exista el registro o lo creo
        .then((row) => {
          const newObj = { id: store, date: new Date(new Date().setFullYear(new Date().getFullYear() - 10)) } as ControlType;
          if (!row) return service.add(Stores.StoreControl, newObj).then(() => newObj);
          return Promise.resolve(row);
        })
        // chequeo el registro de control
        .then(check => {
          return (moment(new Date()).diff(moment(new Date(check.date)), 'minutes') > 15);
        })
        // devuelvo la info desde la db o la busco en el API y actualizo la db
        .then((refresh: boolean) => {
          if (!refresh) 
            return service.all<T>(store).then(data => ({ success: true, data }) as IResponse<T[]>);  // usa db
    
          return api().then(res => {
            return service.clear(store)
              .then(() => service.addRange(store, res.data ?? []))
              .then(() => service.put(Stores.StoreControl, { id: store, date: new Date() }))
              .then(data => ({ success: true, data: res.data }) as IResponse<T[]>);
          })
        })
    }
  }
}